let mainList = []

const TestScheduleListManage = (data, type, e) => {

  switch(type) {
    case "initial":
      return initialTestScheduleMap(data)

    case "add":
      return addScheduleToScheduleList(e, data)

    case "remove":
      return removeStsIdsFromScheduleList(data)

    case "find":
      return findScheduleFromScheduleList(e, data)
    
    case "removeMainList":
      return removeMainList()

    default:
      return mainList
  }

}

function removeMainList(){
  mainList.length = 0
  mainList = []
}

function initialTestScheduleMap(targets){
  for (let index = 0; index < targets.length; index++) {
    const item = targets[index];
    let obj = {}
    let dataset = item.dataset
    if (!dataset.testScheduleId){
      return
    }
    obj['id'] = dataset.id
    obj['tsId'] = parseInt(dataset.testScheduleId)
    obj['stsId'] = parseInt(dataset.stsId)
    obj['specimenId'] = parseInt(dataset.specimenId)      
    mainList.push(obj)
  }
  return mainList
}


function addScheduleToScheduleList(e, data){  
  let stsData = data.sts
  for (let index = 0; index < stsData.length; index++) {
    const element = stsData[index];
    let obj = {}
    obj['id'] = e.target.dataset.id
    obj['tsId'] = element.test_schedule_id
    obj['stsId'] = element.id
    obj['specimenId'] = element.specimen_id
    mainList.push(obj)
  }
  return mainList
}

function removeStsIdsFromScheduleList(currentSchItems){
  for (let index = 0; index < currentSchItems.length; index++) {
    const willDelete = currentSchItems[index];
    const objWithIdIndex = mainList.findIndex(
      (obj) => obj.id == willDelete.id && obj.tsId == willDelete.tsId && obj.stsId == willDelete.stsId && obj.specimenId == willDelete.specimenId
    );
    if (objWithIdIndex > -1) {
      mainList.splice(objWithIdIndex, 1);
    }
  }
  return mainList
}

function findScheduleFromScheduleList(e, specimenIds){
  // TODO -  Target find doesn't work efficiently and accuratly and decided using findElementByClass method
  // const testScheduleIdTarget = this.findTargetByDatasetId(this.autoCompleteHiddenTargets, e) 

  const testScheduleIdTarget = findElementByClass("form-control record-value", e)
  let tsId = testScheduleIdTarget ? testScheduleIdTarget.value : ""
  if (!tsId){
    // alert("There is a problem. Please try again to select a test and specimens!")
    console.warn("There is a problem. You already deleted this test or try reselect a test and specimens!");
    return
  }

  let currentStsIds = []
  let currentItems = []
  for (let index = 0; index < mainList.length; index++) {
    const item = mainList[index];
    if  (item['id'] == e.target.dataset.id && specimenIds.indexOf(parseInt(item['specimenId'])) >= 0 && item['tsId'] && tsId == item['tsId']){
      currentStsIds.push(parseInt(item['stsId']))
      currentItems.push(item)
    }
  }
  return [currentStsIds, currentItems]
}

function findElementByClass(_class, e){
  const hiddenElements = document.getElementsByClassName(_class)
  for (let index = 0; index < hiddenElements.length; index++) {
    const element = hiddenElements[index];
    if (element.dataset.id == e.target.dataset.id ){
      return element
    }
  }
}


export default TestScheduleListManage